import _assign from "object-assign";

/**
 * A facade for MUI withStyles.
 *
 * Defines a style callback that is called everytime the theme changes.
 * The style callback creates a JSS object which is injected as CSS into the
 * DOM, as required.
 *
 * The HOC then provides a `classes` property to the
 * wrapped component mapping the JSS object key to the dynamic CSS selector.
 * @example
 * const style = theme => {
 *    return {
 *       myselector: {
 *          '. mycssrule': {
 *               color: value
 *          }
 *       }
 *    }
 * }
 * withStyles(style)(ComponentToTheme)
 *
 * Components style the elements by applying the classes property
 * to elements
 * @example
 * render() {
 *     return <span className={this.props.classes.myselector}/>
 * }
 */
import { withStyles as withStylesWithoutDefault } from '@material-ui/styles';
import defaultTheme from './internal/defaultTheme';
export default function withStyles(stylesOrCreator, options) {
  return withStylesWithoutDefault(stylesOrCreator, _assign({
    defaultTheme: defaultTheme
  }, options));
}